import { render, staticRenderFns } from "./editAdSeries.vue?vue&type=template&id=2fe6c7ce"
import script from "./editAdSeries.vue?vue&type=script&lang=js"
export * from "./editAdSeries.vue?vue&type=script&lang=js"
import style0 from "./editAdSeries.vue?vue&type=style&index=0&id=2fe6c7ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports